import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useLanguage } from '@/hooks/useLanguage';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Button } from '../ui/button';
import { Globe } from 'lucide-react';
import { cn } from '@/lib/utils';
export const LangPicker = React.memo(({ triggerClassName }) => {
    const { availableLanguages, currentLanguage, getCurrentLanguageName, setLanguage, isInitialized } = useLanguage();
    if (!isInitialized || availableLanguages.length === 0)
        return null;
    return (_jsxs(DropdownMenu, { children: [_jsx(DropdownMenuTrigger, { asChild: true, children: _jsx("div", { children: _jsxs(Button, { variant: "ghost", className: cn("min-w-[80px]", triggerClassName), children: [_jsx(Globe, { className: "size-4 stroke-1" }), _jsx("span", { className: 'text-sm font-normal', children: getCurrentLanguageName() })] }) }) }), _jsx(DropdownMenuContent, { align: "end", sideOffset: 4, children: availableLanguages.map((language) => (_jsx(DropdownMenuItem, { onClick: () => {
                        setLanguage(language.isoCode);
                    }, children: language.caption }, language.isoCode))) })] }));
});
